export default __webpack_public_path__ + "static/media/badge.dba36274.svg";